import { render, staticRenderFns } from "./ModalLastxAlerts.vue?vue&type=template&id=a47da780"
import script from "./ModalLastxAlerts.vue?vue&type=script&lang=js"
export * from "./ModalLastxAlerts.vue?vue&type=script&lang=js"
import style0 from "./ModalLastxAlerts.vue?vue&type=style&index=0&id=a47da780&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports